<template>
    <div class="container" style="padding-left:0px">
        <b-form-group label-cols="2" :label="$t('general.size')" label-for="input-size">
            <b-form-select class="mayrinput" v-model="computedSelectedSize" :options="partSizeOptions" />
        </b-form-group>
    </div>
</template>

<script>
    export default {
        name: "SizeInput",
        props: ['partSizes', 'maxStklId'],
        computed: {
            partSizeOptions: function() {
                let tmp = [];
                for (const [maxStklId, size] of this.partSizes.entries()) {
                    tmp.push( {value:maxStklId, text:size}) ;
                }
                return tmp;
            },
            computedSelectedSize: {
                get() {
                    return this.maxStklId;
                },
                set(value) {
                    let size = this.partSizes.get(value);
                    let maxStklId = value;
                    this.$store.dispatch('updateSize', {maxStklId: maxStklId, size: size})
                        .then(response => {
                          if(response.konfigModel.stuecklistenInfos.length === 0){
                            this.$store.commit('setKonfigModel', {})
                            this.$store.dispatch('initModelByMaxStklId', {maxStklId: maxStklId, reset: true})
                          }
                        });
                }
            }
        }
    }
</script>

<style scoped>

    .mayrinput {
        border-radius: 0px
    }

</style>